export default ({ user }) => ['moderator', 'platform-owner'].includes(user.role.type);
